import React from 'react';
import PropTypes from 'prop-types';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { FooterWrapper, FooterText, FooterTextWrapper } from '../styles';
import { LPText } from '../../styles';
import { StyledButton } from '../../../components/Forms/styles';

const BookingFooter = ({ handleClick, footerHeading, footerParagraph }) => (
  <FooterWrapper>
    <StyledButton bgcolor="var(--background-secondary-color)" onClick={handleClick}>
      <FooterTextWrapper>
        <FooterText>{footerHeading}</FooterText>
        <LPText small lowercase nomargin>
          {footerParagraph}
        </LPText>
      </FooterTextWrapper>

      <ArrowForwardIcon />
    </StyledButton>
  </FooterWrapper>
);

BookingFooter.defaultProps = {
  handleClick: () => {},
};

BookingFooter.propTypes = {
  handleClick: PropTypes.func,
  footerHeading: PropTypes.string.isRequired,
  footerParagraph: PropTypes.string.isRequired,
};

export default BookingFooter;
